import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    blnError: { label: i18n.t('uploaderrors.state'), value: '', compareType: 'boolean' },
    'distribuidor.idDistribuidor': { label: i18n.t('uploaderrors.idDistribuidor'), value: '', comparator: 'equals' },
    empresa: { label: i18n.t('uploaderrors.cliente'), value: '', compareType: 'function', callback: (item, value, key) => item?.cliente?.idCliente === value },
    codError: { label: i18n.t('uploaderrors.codError'), value: '' },
    msgError: { label: i18n.t('uploaderrors.msgError'), value: '' },
    Respuesta: { label: i18n.t('uploaderrors.facturaName'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
    { field: 'distribuidor.idDistribuidor', width: '150px', title: i18n.t('uploaderrors.idDistribuidor'), columnMenu: 'myTemplate', locked: false, hidden: true, only: { roles: [3], }, },
    { field: 'distribuidor.Nombre', width: '250px', title: i18n.t('uploaderrors.distribuidor'), columnMenu: 'myTemplate', locked: false, hidden: true, only: { roles: [3], }, },
    { field: 'cliente.idCliente', width: '150px', title: i18n.t('uploaderrors.idCliente'), columnMenu: 'myTemplate', locked: false, hidden: true, only: { roles: [8, 3], }, },
    { field: 'cliente.Nombre', width: '250px', title: i18n.t('uploaderrors.cliente'), columnMenu: 'myTemplate', locked: false, hidden: true, only: { roles: [8, 3], }, },
    { field: 'Respuesta', width: '350px', title: i18n.t('uploaderrors.facturaName'), columnMenu: 'myTemplate', locked: false },
    { field: 'codError', width: '120px', title: i18n.t('uploaderrors.codError'), columnMenu: 'myTemplate', locked: false },
    { field: 'msgError', width: '720px', title: i18n.t('uploaderrors.msgError'), columnMenu: 'myTemplate', locked: false },
  ]
}
const mystore = parent({ navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
